module.exports = __webpack_public_path__ + "static/media/safety-hydraulics-1.93139834.png";